export abstract class UsStates {
    private static _states: Map<string, string> = new Map([
        ['ak', 'alaska'],
        ['al', 'alabama'],
        ['ar', 'arkansas'],
        ['az', 'arizona'],
        ['ca', 'california'],
        ['co', 'colorado'],
        ['ct', 'connecticut'],
        ['dc', 'district of columbia'],
        ['de', 'delaware'],
        ['fl', 'florida'],
        ['ga', 'georgia'],
        ['hi', 'hawaii'],
        ['ia', 'iowa'],
        ['id', 'idaho'],
        ['il', 'illinois'],
        ['in', 'indiana'],
        ['ks', 'kansas'],
        ['ky', 'kentucky'],
        ['la', 'louisiana'],
        ['ma', 'massachusetts'],
        ['md', 'maryland'],
        ['me', 'maine'],
        ['mi', 'michigan'],
        ['mn', 'minnesota'],
        ['mo', 'missouri'],
        ['ms', 'mississippi'],
        ['mt', 'montana'],
        ['nc', 'north carolina'],
        ['nd', 'north dakota'],
        ['ne', 'nebraska'],
        ['nh', 'new hampshire'],
        ['nj', 'new jersey'],
        ['nm', 'new mexico'],
        ['nv', 'nevada'],
        ['ny', 'new york'],
        ['oh', 'ohio'],
        ['ok', 'oklahoma'],
        ['or', 'oregon'],
        ['pa', 'pennsylvania'],
        ['ri', 'rhode island'],
        ['sc', 'south carolina'],
        ['sd', 'south dakota'],
        ['tn', 'tennessee'],
        ['tx', 'texas'],
        ['ut', 'utah'],
        ['va', 'virginia'],
        ['vt', 'vermont'],
        ['wa', 'washington'],
        ['wi', 'wisconsin'],
        ['wv', 'west virginia'],
        ['wy', 'wyoming'],
    ]);

    private static _abbreviations: Map<string, string> = new Map(
        Array.from(this._states, ([key, value]) => [value, key])
    );

    public static getStateName(abbrv: string) {
        return this._states.get(abbrv.toLowerCase()) ?? '';
    }

    public static getStateAbbreviation(name: string) {
        return this._abbreviations.get(name.toLowerCase()) ?? '';
    }
}
